import { createSelector } from 'reselect'
import { FlightSeatRef } from 'businessTraveller/utils/tripRequestSeatUtils'

const selectCheckoutSeatSelectionsByKey = (state: App.State) => state.checkout.form?.flightSeatSelections ?? {}
const selectFlightsSeatSelectionsByKey = (state: App.State) => state.flights?.seatSelections ?? {}

export const getFlightSeatSelectionsByKey = createSelector(
  [selectCheckoutSeatSelectionsByKey, selectFlightsSeatSelectionsByKey],
  (checkoutSeatSelections, flightSeatSelections): Record<string, Record<string, Record<string, App.FlightsSeatsItem>>> => ({
    ...checkoutSeatSelections,
    ...flightSeatSelections,
  }),
)

/** Every seat currently selected at checkout, keyed carrierCode-flightNumber (`QF-490`). */
export const getRequestedFlightSeats = createSelector(
  [getFlightSeatSelectionsByKey],
  (seatSelectionsByKey): Array<FlightSeatRef> => Object.values(seatSelectionsByKey).flatMap(
    segmentSeats => Object.entries(segmentSeats).flatMap(
      ([flightNumber, travellerSeats]) => Object.values(travellerSeats).map(seat => ({ flightNumber, seatNumber: seat.seatNumber })),
    ),
  ),
)

export const hasAnyFlightSeatsSelected = createSelector(
  [getFlightSeatSelectionsByKey],
  (seatSelectionsByKey): boolean => Object.values(seatSelectionsByKey).some(
    segmentSeats => Object.values(segmentSeats).some(
      travellerSeats => Object.keys(travellerSeats).length > 0,
    ),
  ),
)
